import { atom } from 'jotai';

export const isPreferenceMenuOpen = atom(false);
export const isIndicatorPreferenceOpen = atom(false);
